module.exports = __webpack_public_path__ + "img/light_1_0.09b13b35.png";